import { buildHtml, buildLink, RouteSlotInput, SidebarGroup } from '@luks/ui';

import { buildDrupalImage } from '../Image';
import { ParagraphOptions } from './AllParagraphs';

export const mapTeaser = (
  teaser: TeaserFragment,
  context: { payload?: ParagraphOptions },
): RouteSlotInput<typeof SidebarGroup, 'items', 'Teaser'> => {
  return {
    key: 'Teaser',
    input: {
      teaser: {
        arrowIsVisible: true,
        Description: buildHtml(teaser.lead || ''),
        Image: teaser.image
          ? buildDrupalImage(teaser.image, 'teaser')
          : undefined,
        title: teaser.title || '',
        Link: teaser.link?.url
          ? buildLink({ href: teaser.link.url })
          : buildLink({ href: '/' }),
      },
      inSidebar: !!context.payload?.inSidebar,
    },
  };
};
